import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserAuth } from "./context/UserAuthContext";
import Context from "./context/Context";

function ProtecedRoute(props) {
  const { Component, organiserId } = props;
  const navigate = useNavigate();
  const { currentUser, guestModeEnabled } = useUserAuth();
  const { organizerName } = useContext(Context);
  const location = useLocation();
  useEffect(() => {
    if (!currentUser) {
      navigate(`/signup`, {
        state: { previousLocation: location?.pathname },
      });
    }
  });
  return (
    <div>
      <Component />
    </div>
  );
}

export default ProtecedRoute;
